class DomHelper {

    static elementExists (elem) {
        return elem !== undefined && elem !== 'undefined' && elem !== null;
    }

    static enablePageScroll (classname) {
        let wrapper = document.getElementById('overflow-wrapper'),
          top = parseInt(wrapper.style.top, 10) * -1;

        if(wrapper.classList.contains(classname)) {
            wrapper.classList.remove(classname);
            wrapper.style.top = '';

            window.scrollTo(0, parseInt(top, 10));
        }
    }

    static elementInViewport (el) {
        let top = el.offsetTop;
        let left = el.offsetLeft;
        let width = el.offsetWidth;
        let height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
          top < (window.pageYOffset + window.innerHeight) &&
          left < (window.pageXOffset + window.innerWidth) &&
          (top + height) > window.pageYOffset &&
          (left + width) > window.pageXOffset
        );
    }

    static getWindowInnerWidth () {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    static maxValueInArray (array) {
        return Math.max.apply(Math, array);
    }

    static isTouchDevice () {
        return ('ontouchstart' in document.documentElement);
    }

    static stopPageScroll (classname) {
        let wrapper = document.getElementById('overflow-wrapper');

        if(!wrapper.classList.contains(classname)) {
            wrapper.style.top = '-' + window.scrollY + 'px';
            wrapper.classList.add(classname);
        }
    }
}

export {
    DomHelper
};
